import { DatePickerProps } from '@app/types'
import { DatePicker as AntDatePicker } from 'antd'

export const EntityDatePicker: React.FC<DatePickerProps> = (props) => <AntDatePicker {...props} />
